import { AbstractPmsApiService } from "./abstract.service";
import { ChannelRatesInventoryLog } from "../models";

/**
 * @class ChannelRatesInventoryLogPmsApiService
 * @abstract
 * @extends {AbstractPmsApiService<ChannelRatesInventoryLog>}
 */
export class ChannelRatesInventoryLogPmsApiService extends AbstractPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/property/:propertyId/channel-log/rates-inventory';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {ChannelRatesInventoryLog}
     * @protected
     */
    newModel(attributes, ...params) {

        return new ChannelRatesInventoryLog(attributes);
    }

    /**
     * @param {Object=} params
     * @param {Property=} property
     * @returns {Promise.<PaginationCollection<ChannelRatesInventoryLog>>}
     */
    get(params = {}, property) {

        const url = this.url({propertyId: property.id});

        return this.http
            .get(url, {
                headers: this.authHeaders,
                params,
            })
            .then(this.getPaginationCollector())
            .catch(this.getErrorHandler());
    }
}


// WEBPACK FOOTER //
// ./src/pms-api/services/channel-rates-inventory-log.service.js